<template>
  <div id="ModelCallHistory">
    <a-modal
      title="通话历史"
      width="620px"
      :visible="this.$store.state.isShowCallHistoryModel"
      @cancel="closeModel"
      @ok="closeModel"
    >
      <a-table
        :columns="callHistoryColumns"
        :rowKey="record => record.ID"
        :dataSource="tableCallHistoryData"
        size="small"
        :pageSize="2"
      >
        <div slot="telB" slot-scope="text">
          {{ text | hidePhone }}
        </div>
        <div slot="Starttimecaller" slot-scope="text">
          {{ text | timeFilter }}
        </div>
        <div slot="duration" slot-scope="text">
          {{ text | stom }}
        </div>
        <div slot="recordUrl" slot-scope="text, record">
          <template v-if="isShowRecordUrl(record.recordUrl)">
            <a
              v-on:click="playAudioURL(record.ID)"
              :id="setAudioBtnID(record.ID)"
              >播放</a
            >
            |
            <audio :src="record.recordUrl" :id="record.ID">
              您的浏览器不支持audio
            </audio>
            <a :href="record.recordUrl">下载</a>
          </template>
          <template v-else>
            -
          </template>
        </div>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { GetCallHistoryWithCrmID } from '@/api/QkidsApi.js'

const callHistoryColumns = [
  { title: '电话', dataIndex: 'telB', key: 'telB', scopedSlots: { customRender: 'telB' } },
  { title: '发起时间', dataIndex: 'Starttimecaller', key: 'Starttimecaller', scopedSlots: { customRender: 'Starttimecaller' } },
  { title: '通话时长', dataIndex: 'duration', key: 'duration', scopedSlots: { customRender: 'duration' } },
  { title: '录音管理', dataIndex: 'recordUrl', key: 'recordUrl', scopedSlots: { customRender: 'recordUrl' } }
]
export default {
  name: 'ModelCallHistory',
  data () {
    return {
      selectCrmID: this.modelCallHistoryCrmid,
      callHistoryColumns,
      tableCallHistoryData: []
    }
  },
  props: {
    modelCallHistoryCrmid: Number
  },
  methods: {
    closeModel (e) {
      this.$store.state.isShowCallHistoryModel = false
    },
    isShowRecordUrl: (url) => {
      if (url === '') {
        return false
      } else {
        return true
      }
    },
    playAudioURL: function (str) {
      var audio = document.getElementById(str)
      var btn = document.getElementById('btn' + str)
      if (audio.paused) {
        audio.play()
        btn.innerHTML = '暂停'
      } else {
        audio.pause()
        btn.innerHTML = '继续播放'
      }
      btn.addEventListener('ended', function () {
        btn.innerHTML = '重新播放'
      })
    },
    setAudioBtnID: function (str) {
      return 'btn' + str
    }
  },
  watch: {
    modelCallHistoryCrmid: function () {
      this.selectCrmID = this.modelCallHistoryCrmid
      if (this.selectCrmID === 0) {
        this.tableCallHistoryData = []
      } else {
        GetCallHistoryWithCrmID(this.selectCrmID)
          .then(req => {
            this.tableCallHistoryData = req.data
            console.log(req)
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  filters: {
    timeFilter: (val) => {
      val = val.replace('T', ' ')
      val = val.replace('+08:00', '')
      return val
    },
    hidePhone: (phone) => {
      return phone.toString().substr(0, 3) + '****' + phone.toString().substr(7, 11)
    },
    stom: (value) => {
      var secondTime = parseInt(value)
      var minuteTime = 0
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60)
        secondTime = parseInt(secondTime % 60)
      }
      var result = '' + parseInt(secondTime) + '秒'
      if (minuteTime > 0) {
        result = '' + parseInt(minuteTime) + '分' + result
      }
      return result
    }
  }
}
</script>
